"use client";

import { Navbar } from "@/components/hyper-or/Navbar";
import { Hero } from "@/components/hyper-or/Hero";
import { BoutiquesGrid } from "@/components/hyper-or/BoutiquesGrid";
import { PromotionsSection } from "@/components/hyper-or/PromotionsSection";
import { ChefPicksSection } from "@/components/hyper-or/ChefPicksSection";
import { ExperienceSection } from "@/components/hyper-or/ExperienceSection";
import { RecipesSection } from "@/components/hyper-or/RecipesSection";
import { LaTableHyperOR } from "@/components/hyper-or/LaTableHyperOR";
import { AboutSection } from "@/components/hyper-or/AboutSection";
import { ServicesSection } from "@/components/hyper-or/ServicesSection";
import { JournalSection } from "@/components/hyper-or/JournalSection";
import { LocationSection } from "@/components/hyper-or/LocationSection";
import { NewsletterSection } from "@/components/hyper-or/NewsletterSection";
import { Footer } from "@/components/hyper-or/Footer";
import { boutiques } from "@/lib/products-data";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-cream text-ink">
      <Navbar />
      <main className="flex-1">
        {/* Section 1 — Hero (top) */}
        <Hero />

        {/* Section 2 — Categories : 12 boutiques en grille (lien vers sections détaillées) */}
        <BoutiquesGrid />

        {/* Section 3 — Promotions : 12 promos FCFA avec filtres */}
        <PromotionsSection />

        {/* Section 4 — Chef Picks : 5 sélections du moment */}
        <ChefPicksSection />

        {/* Section 5 — Experience : Allée Centrale + Témoignage + 4 services */}
        <ExperienceSection />

        {/* Section 6 — Recipes : La table d'Hyper OR (3 recettes chefs) */}
        <RecipesSection />

        {/* Section 7 — Les 12 boutiques détaillées, chacune avec 50 produits */}
        {boutiques.map((b, idx) => (
          <BoutiqueSectionFull key={b.id} boutique={b} index={idx} />
        ))}

        {/* Section 8 — La Table d'Hyper OR : catalogue maître interactif (600 produits) */}
        <LaTableHyperOR />

        {/* Section 9 — About : SENE & DIA + 3 piliers */}
        <AboutSection />

        {/* Section 10 — Services : 6 services + Club OR Premium */}
        <ServicesSection />

        {/* Section 11 — Journal : 3 articles */}
        <JournalSection />

        {/* Section 12 — Location : 12 Bd Haussmann + horaires + map */}
        <LocationSection />

        {/* Section 13 — Newsletter : Le Cercle OR */}
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}

// Wrapper to avoid name clash with imported BoutiqueSection
import { BoutiqueSection } from "@/components/hyper-or/BoutiqueSection";
function BoutiqueSectionFull(props: {
  boutique: typeof boutiques[number];
  index: number;
}) {
  return <BoutiqueSection {...props} />;
}
